import { render, staticRenderFns } from "./tenantid.vue?vue&type=template&id=51dc8f2a&"
import script from "./tenantid.vue?vue&type=script&lang=js&"
export * from "./tenantid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports